export default "__VITE_ASSET__98732dd3__"